module.exports = {"TXTWCL_Player_Funds_Protection":{"id":"TXTWCL_Player_Funds_Protection","defaultMessage":"顧客資金の保護"}}